export default __webpack_public_path__ + "static/media/oa_0.38506cff.mp3";